const events = {}

export const addListener = (type, func) => {
  if (!events[type]) {
    events[type] = []
  }
  events[type].push(func)
}

export const removeListener = (type, func) => {
  if (!events[type]) {
    return
  }
  const idx = events[type].indexOf(func)
  if (idx >= 0) {
    events[type].splice(idx)
  }
}

export const emit = (type, event) => {
  if (!events[type]) {
    return
  }
  events[type].forEach((func) => {
    func(event)
  })
}
